import { Box, VStack } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const SignUpHomeContainer = Box.withConfig<{ $backgroundColor?: string | null }>(
  ({ $backgroundColor }) => ({
    flex: 1,
    background: $backgroundColor ?? theme.token('background-default'),
  })
);

export const AuthContainer = VStack.withConfig({
  flex: 1,
  maxWidth: {
    base: '100%',
    sm: '564px',
  },
  minHeight: {
    base: '100%',
    sm: '84.3%',
  },
  marginX: {
    base: 0,
    sm: 'auto',
  },
  justifyContent: {
    base: 'flex-start',
    sm: 'center',
    md: 'center',
  },
  paddingBottom: {
    base: 0,
    sm: '10',
    xl: '11',
  },
  _web: {
    flex: 'none',
    width: 'full',
  },
});

export const SignUpContainer = Box.withConfig<{ isSignIn?: boolean }>(p => ({
  flex: 1,
  backgroundColor: theme.token('background-pattern'),
  borderTopRadius: '30px',
  borderBottomRadius: {
    base: 0,
    sm: '8',
  },
  paddingTop: '3',
  paddingBottom: '3',
  minWidth: {
    base: '100%',
    sm: '400px',
  },
  minHeight: {
    sm: '560px',
  },
}));

export const SignUpPanel = Box.withConfig({
  marginY: '$7',
  marginX: {
    base: '6%',
    md: '$7',
  },
});
